/**
 * エントリポイント。
 * DOM を掴んで Game を起動するだけ。ゲームの中身は engine/game.ts に集約する。
 */

import './ui/styles.css';
import { Game } from './engine/game';

function showBootError(message: string, detail: string): void {
  const root = document.getElementById('ui-root');
  if (!root) return;
  const panel = document.createElement('div');
  panel.className = 'boot-error';
  panel.innerHTML = '';
  const inner = document.createElement('div');
  inner.className = 'boot-error-panel';
  const title = document.createElement('h2');
  title.textContent = message;
  const body = document.createElement('p');
  body.textContent = detail;
  inner.append(title, body);
  panel.append(inner);
  root.append(panel);
}

function boot(): void {
  const canvas = document.getElementById('game-canvas');
  const uiRoot = document.getElementById('ui-root');
  if (!(canvas instanceof HTMLCanvasElement) || !uiRoot) {
    showBootError('起動できませんでした', '必要な要素が index.html に見つかりません。');
    return;
  }

  try {
    const game = new Game(canvas, uiRoot);
    game.start();
    // 開発時の確認用（本番でも害はないが、参照は保持しておく）
    (window as unknown as { __netops?: Game }).__netops = game;
  } catch (error) {
    console.error(error);
    showBootError(
      '起動できませんでした',
      error instanceof Error ? error.message : String(error),
    );
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
